import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Image from '../Assets/plsprint.png'
import { useContext, useEffect } from 'react'
import UserContext from '../context/UserContext'

const Dashboard = () => {


  


    useEffect(() => {
        let h = sessionStorage.getItem('user')
    if(h){

    }else{
        nav('/',{replace: true})   
    }
    },[])


   

    const location = useLocation()
    const path = window.location.pathname
   const nav = useNavigate()
const {logout,userInfo} = useContext(UserContext)

  return (
    <> 
   
    <div className="w-full h-[10vh] border-b-5 border-[#7ABB43] flex justify-center items-center px-20">
                <div className="flex-1 ">
                    <img width="150" height="200" alt="PLS Logo" src={Image} />
                </div>
                <div className="flex-1 text-center text-xl">Welcome Back {userInfo.name}</div>
                <div className="flex-1   space-x-8  text-right">
                  {
                   userInfo.level !== '0' && <button
                        type="button"
                         className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                    >
                        Account
                    </button>
                  }
                    <button
                        type="button"
                        className="text-white bg-red-400 hover:bg-red-400 font-medium rounded-full text-sm px-5 py-2.5"
                        onClick={logout}
                    >
                        Logout
                    </button>
                </div>
            </div>

     
            <Outlet />
           
          </>
  )
}

export default Dashboard